import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "act", "over", "night", "hol",
    "colAct", "colOver", "colNight", "colHol",
    "calendarBody"
  ]

  connect() {
    this.renderCurrentMonth()
  }

  toggleAct(event) {
    this.setColumn(this.actTargets, this.colActTarget, event.target.checked)
  }

  toggleOver(event) {
    this.setColumn(this.overTargets, this.colOverTarget, event.target.checked)
  }

  toggleNight(event) {
    this.setColumn(this.nightTargets, this.colNightTarget, event.target.checked)
  }

  toggleHol(event) {
    this.setColumn(this.holTargets, this.colHolTarget, event.target.checked)
  }

  setColumn(cells, col, show) {
    cells.forEach(el =>
      el.classList.toggle("hide-col", !show)
    )
    col.classList.toggle("hide-col", !show)
  }

   changeMonth(event) {
    const value = event.target.value
    if (!value) return

    const [year, month] = value.split("-").map(Number)
    this.renderMonth(year, month)
  }

  renderCurrentMonth() {
    const now = new Date()
    this.renderMonth(now.getFullYear(), now.getMonth() + 1)
  }

  renderMonth(year, month) {
    const daysInMonth = new Date(year, month, 0).getDate()
    this.calendarBodyTarget.innerHTML = ""

    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month - 1, day)
      this.calendarBodyTarget.appendChild(this.buildRow(date))
    }
  }

  buildRow(date) {
    const tr = document.createElement("tr")
    tr.className = "day-row"
    tr.dataset.date = date.toISOString().slice(0, 10)
    tr.dataset.day = date.getDate()

    const w = date.getDay()
    const youbi = ["日", "月", "火", "水", "木", "金", "土"]

    tr.innerHTML = `
      <td>${date.getDate()}</td>
      <td class="${w === 0 ? "sunday" : w === 6 ? "saturday" : ""}">
        ${youbi[w]}
      </td>
      <td>
        <input type="checkbox" class="holiday" ${w === 0 || w === 6 ? "checked" : ""}>
      </td>
      <td>
        <select class="att-type">
          <option value="">通常</option>
          <option value="full">有休(1日)</option>
          <option value="am">有休(午前)</option>
          <option value="pm">有休(午後)</option>
        </select>
      </td>
      <td><input type="time" class="start"></td>
      <td><input type="time" class="end"></td>
      <td class="act hide-col">0時間0分</td>
      <td class="over hide-col">0時間0分</td>
      <td class="night hide-col">0時間0分</td>
      <td class="hol hide-col">0時間0分</td>
      <td>
        <div class="site-wrapper">
          ${this.siteRowTemplate()}
        </div>
      </td>
    `
    return tr
  }

  siteRowTemplate() {
    return `
      <div class="site-row-wrapper" data-controller="personal-attendances--table">
        <div class="site-row">

          <span class="site-buttons">
            <button type="button"
                    class="site-add"
                    data-action="click->personal-attendances--table#addRow">＋</button>
            <button type="button"
                    class="site-remove"
                    data-action="click->personal-attendances--table#removeRow">－</button>
          </span>

          <select name="project" class="site-name">
            <option value=""></option>
          </select>

          <select class="site-shift">
            <option value=""></option>
            <option value="1">1：1日</option>
            <option value="2">2：午前</option>
            <option value="3">3：午後</option>
          </select>

          <input type="time" class="site-start">
          <input type="time" class="site-end">
          <input type="time" class="site-hours">
          <input type="number" class="site-men" step="0.01">
          <input type="text" class="site-task" list="taskList">
          <input type="text" class="site-machine" list="machineList">
          <input type="time" class="site-machine-hours">
          <input type="text" class="site-lease">

          ${this.allowanceInputs()}
        </div>
      </div>
    `
  }

  allowanceInputs() {
    const count = Number(
      getComputedStyle(this.element)
        .getPropertyValue("--allowance-count")
    ) || 0

    let html = ""
    for (let i = 1; i <= count; i++) {
      html += `<input type="number"
                      class="site-allow${i}"
                      min="0">`
    }
    return html
  }
}
